export const TASK_DISPLAY_NAME = 'To-do';
